module.exports = __webpack_public_path__ + "static/media/license.e1850fa5.svg";